import { NotificationProgrammatic as Notification } from 'buefy/dist/components/notification';

export const showNotification = (notificationType, optionalParams) => { // eslint-disable-line
  const notification = {
    queue: false,
    ...notificationType,
    ...optionalParams,
  };

  Notification.open(notification);
};
